import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort} from '@angular/material';
import {Subscription} from 'rxjs';
import {Offset} from '../../../models/Offset';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {ConsuntivoVolumiModel} from '../../../models/ConsuntivoVolumiModel';
import {ConsuntivoVolumiService} from './service-consuntivo-volumi/consuntivo-volumi.service';
import {NumAnnoMeseService} from '../../general-services/service-num-anno-mese/num-anno-mese.service';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {Router} from '@angular/router';
import {ProviderModel} from '../../../models/ProviderModel';
import {ContractTypeService} from '../../general-services/service-contract-type/contract-type.service';
import {UsersService} from '../../users/service/users.service';

@Component({
  selector: 'app-consuntivo-volumi',
  templateUrl: './consuntivo-volumi.component.html',
  styleUrls: ['./consuntivo-volumi.component.scss']
})
export class ConsuntivoVolumiComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  sectionId: string;

  displayedColumns: Array<string>;
  dataSource: any;
  isConsumptiveSection: boolean;
  selectedRowIndex: number;
  listData: MatTableDataSource<any>;

  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;

  isMocked: boolean;
  showFilter: boolean;

  offset: Offset;
  filter: ConsuntivoVolumiModel;
  numAnnoMeseData: any;
  contractTypeData: any;

  providerSelected: ProviderModel;


  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Input() reportSection?: boolean;
  @Input() isRecovery?: number;

  @Output() elementSelected = new EventEmitter();

  constructor(private consuntivoVolumiService: ConsuntivoVolumiService,
              private numAnnoMeseService: NumAnnoMeseService,
              private contractTypeService: ContractTypeService,
              private userService: UsersService,
              private loaderService: LoaderService,
              private dialog: MatDialog,
              private router: Router) {
    super();
    this.loaderService.display(true);

    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.sectionId = this.SECTIONS.MONTHLY_ACTUALS;
  }

  ngOnInit() {
    this.isConsumptiveSection = this.returnIsContractSection(this.router.url);
    this.selectedRowIndex = -1;
    this.providerSelected = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;

    if (this.providerSelected.description === this.PROVIDER_IBM) {
      this.displayedColumns = ['numAnnoMeseRif', 'regionDesc', 'localCustomerDesc', 'contractTypeDesc',
        'resourceUnitCod', 'resourceUnitName',  'designServicesDesc', 'unitsDesc', 'shareName',
        'applicationDescription', 'vol', 'actions'];
    } else {
      this.displayedColumns = ['serviceDate', 'numAnnoMeseRif', 'regionDesc', 'localCustomerDesc', 'contractTypeDesc',
        'resourceUnitCod', 'resourceUnitName',  'designServicesDesc', 'unitsDesc',
        'applicationDescription', 'serviceVariantCod', 'size', 'site',
        'numAnnoMeseAcceptance', 'ulbStatus', 'requestId', 'requestDescription',
        'instanceName', 'systemName', 'monthlyForecastQuantity', 'approverRequestor',
        'deviceNameServerName', 'actualQuantity', 'actions'];
    }

    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.CONSUNTIVO_VOLUMI_OFFSET);
    this.getSessionStorageFilter();
    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });
    this.init();
  }

  init() {
    this.filter.provider = this.providerSelected;
    this.filter.isRecovery = this.isRecovery;
    this.numAnnoMeseService.getAllMonth(this.filter.contractType).subscribe(
      (resultYearMonth: any) => {
        this.numAnnoMeseData = resultYearMonth;

        if (!this.filter.numAnnoMese || !BaseGeneralComponent.isNumAnnoMeseInFilterList(this.filter.numAnnoMese, this.numAnnoMeseData)) {
          const numAnnoMese = resultYearMonth[0] ? resultYearMonth[0] : null;
          this.filter.numAnnoMese = numAnnoMese;
        }

        if (!this.reportSection) {
          this.showFilter = false;
          this.getDataPage(this.offset, this.filter);
        } else {
          this.showFilter = true;
        }          }, error => {
        console.log(error);
        this.loaderService.display(false);
      });
  }

  getDataPage(offset: Offset, filter: ConsuntivoVolumiModel) {
    this.getPageSubscribe = this.consuntivoVolumiService.getPage(offset, filter)
      .subscribe(
        (resultPage: any) => {
          this.dataSource = resultPage.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.listData.sort = this.sort;
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = resultPage.totalElements;
          this.loaderService.display(false);
        });
  }

  openDialog(id: number) {
    const consuntivoVolumi = this.dataSource.find(data => data.id === id) as ConsuntivoVolumiModel;
    const list: GenericArray[] = [
      {id: 'Month', value: this.toCustomStringAnnoMese(consuntivoVolumi.numAnnoMese)},
      {id: 'Reference Month', value: this.toCustomStringAnnoMese( consuntivoVolumi.numAnnoMeseRif)},
      {id: 'Provider Cod', value: this.toCustomString( consuntivoVolumi.provider.cod)},
      {id: 'Provider Description', value: this.toCustomString( consuntivoVolumi.provider.description)},
      {id: 'Region Cod', value: this.toCustomString( consuntivoVolumi.region.description)},
      {id: 'Region Description', value: this.toCustomString( consuntivoVolumi.region.description)},
      {id: 'Local Customer Cod', value: this.toCustomString( consuntivoVolumi.localCustomer.cod)},
      {id: 'Local Customer Description', value: this.toCustomString( consuntivoVolumi.localCustomer.description)},
      {id: 'Contract Type Cod', value: this.toCustomString( consuntivoVolumi.contractType.cod)},
      {id: 'Contract Type Description', value: this.toCustomString( consuntivoVolumi.contractType.description)},
      {id: 'Resource Unit Cod', value: this.toCustomString( consuntivoVolumi.resourceUnit.cod)},
      {id: 'Resource Unit Name', value: this.toCustomString( consuntivoVolumi.resourceUnit.name)},
      {id: 'SL1 Cod', value: this.toCustomString( consuntivoVolumi.designServices.cod)},
      {id: 'SL1 Description', value: this.toCustomString( consuntivoVolumi.designServices.description)},
      {id: 'Units Cod', value: this.toCustomString(consuntivoVolumi.units ? consuntivoVolumi.units.cod : null)},
      {id: 'Units Description', value: this.toCustomString(consuntivoVolumi.units ? consuntivoVolumi.units.description : null)},
      {id: 'ShareName', value: this.toCustomString( consuntivoVolumi.shareName)},
      {id: 'Application Description', value: this.toCustomString(consuntivoVolumi.applicationDescription)},
      {id: 'Is Recovery', value: this.toCustomStringIs(consuntivoVolumi.isRecovery)}

    ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.CONSUNTIVO_VOLUMI_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);

  }

  getDataFiltered(dataFiltered: any) {
    if (this.offset === null || this.offset === undefined) {
      this.offset = new Offset(10, 0);
    }
    this.filter = dataFiltered;
    if (!this.reportSection) {
      this.getDataPage(this.offset, this.filter);
    }  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(10, 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getDataPage(this.offset, this.filter);
    }

  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }

    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  toggleFilter() {
    if (!this.reportSection) {
      this.showFilter = !this.showFilter;
    }
  }

  getSessionStorageFilter() {
    const filter_ = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.VOLUME_CONSUMPTIVE_FILTER));
    this.filter = filter_ ? filter_ : new ConsuntivoVolumiModel();
  }

}
